import { render, staticRenderFns } from "./ViewBlackListUserComponent.vue?vue&type=template&id=1b3fbaf0"
import script from "./ViewBlackListUserComponent.vue?vue&type=script&lang=js"
export * from "./ViewBlackListUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports